import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";

import useWindowSize from "hooks/useWindowResize";
import { useSelector } from "react-redux";
import { RootState } from "store";

import LoginPage from "pages/auth/LoginPage";
import HomePage from "pages/home/HomePage";
import ProfilePage from "pages/profile/ProfilePage";
import PayDonePage from "pages/pay-done/PayDonePage";
import Page404 from "pages/page404/Page404";
import SiteHeader from "components/SiteHeader";
import PaymentMethodPage from "pages/payment-method/PaymentMethodPage";
import TermPage from "pages/terms/TermsPage";
import PackagePage from "pages/packages/PackagePage";

export const memberPages: Page[] = [
  { path: "/", component: HomePage },
  { path: "/my-profile", component: ProfilePage },
  { path: "/pay-done", component: PayDonePage },
  { path: "/packages", component: PackagePage },
  { path: "/payment-method", component: PaymentMethodPage },
  { path: "/terms-and-disclamier", component: TermPage },
];

export const publicPages: Page[] = [
  { path: "/", component: HomePage },
  { path: "/login", component: LoginPage },
];

const MyRoutes = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  let WIN_WIDTH = useWindowSize().width;
  if (typeof window !== "undefined") {
    WIN_WIDTH = WIN_WIDTH || window.innerWidth;
  }

  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteHeader />
      <Routes>
        {user &&
          memberPages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component />} path={path} />;
          })}
        {!user &&
          publicPages.map(({ component, path }) => {
            const Component = component;
            return <Route key={path} element={<Component />} path={path} />;
          })}
        <Route element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
};

export default MyRoutes;
